<template>
  <div class="row">
    <div class="col">
      <p>The following is used to set up "opt-in" requirements per Insurance partner agreements.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-3 custom-source">
      <div class="input-group mb-3">
        <span class="input-group-text">Source:</span>
        <select v-model="source" class="form-control custom-select">
          <option v-for="item of sources" :key="item.app" :value="item.appNumber">{{ item.appName }}</option>
        </select>
      </div>
    </div>
    <div class="col-4">
      <Multiselect
        v-show="source !== null"
        ref="searchLocation"
        v-model="foundLocation"
        class="form-control custom-multiselect"
        placeholder="type to search"
        mode="single"
        :close-on-select="true"
        :filter-results="false"
        :min-chars="1"
        :resolve-on-load="false"
        :delay="500"
        :searchable="true"
        :open-direction="'bottom'"
        :options="
          async (query) => {
            return await fetchLocations(query)
          }
        "
        label="firmName"
        value-prop="firm"
        @select="selectedLocation"
      />
    </div>
    <div class="col"></div>
  </div>
  <div class="row mt-3">
    <div class="col-9">
      <div class="row custom-header">
        <div class="col-2"><span>Source</span></div>
        <div class="col"></div>
        <div class="col-3"><span>DRP Identifier</span></div>
        <div class="col-2"><span>Opt-In?</span></div>
        <div class="col-1"></div>
      </div>
      <ul class="custom-list">
        <li v-for="location of companies" :key="`${location.firm2}-${location.source}`">
          <div class="row">
            <div class="col-2">
              <span>{{ location.source }}</span>
            </div>
            <div class="col">
              <span>{{ location.firmName }}</span>
            </div>
            <div class="col-3">
              <input
                :value="location.drpId"
                type="text"
                class="form-control form-control-sm"
                maxlength="100"
                placeholder="DRP Identifier"
                @input="changedDrp(location, $event.target.value)"
              />
            </div>
            <div class="col-2">
              <input
                :checked="location.isOptIn"
                type="checkbox"
                class="custom-checkbox"
                true-value="true"
                false-value="false"
                @change="checkedOptIn(location)"
              />
            </div>
            <div class="col-1 text-center">
              <div @click="removeLocation(location.firm2)">
                <i class="fas fa-trash custom-trash"></i>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'LocationInsurance',
  components: {
    Multiselect
  },
  props: {
    firm: Object
  },
  data() {
    return {
      foundLocation: null,
      isSave: false,
      source: null
    }
  },
  emits: ['saved', 'changed'],
  computed: {
    ...mapState(locationStore, ['location', 'insurance', 'foundLocations', 'apps']),
    sources() {
      let _data = []
      if (this.apps) {
        this.apps.forEach((element) => {
          if (element.appNumber.includes('ADAS') || element.appNumber.includes('Calibrate') || element.appNumber.includes('TestDrive')) {
            _data.push(element)
          }
        })
      }
      return _data
    },
    companies() {
      let _data = []
      if (this.insurance) {
        this.insurance.forEach((element) => {
          if (!element.isRemove) {
            _data.push(element)
          }
        })
      }
      return _data
    }
  },
  methods: {
    ...mapActions(locationStore, ['searchLocations', 'pushInsurance', 'popInsurance', 'saveMembership', 'saveDrps']),
    async fetchLocations(query) {
      let search = {
        search: query,
        type: 4,
        firm: this.location.firm
      }
      return await this.searchLocations(search)
    },
    selectedLocation() {
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.firm) === parseInt(this.foundLocation))
        console.log('Found Location', {
          location: this.location,
          found: found,
          source: this.source
        })
        if (found) {
          this.isSave = true
          let id = null
          let what = null
          if (this.source.substring(0, 4) === 'ADAS') {
            id = this.location.adasId
            if (id === null) {
              what = 'ADAS Map Id'
            }
          } else if (this.source.substring(0, 9) === 'Calibrate') {
            id = this.location.calcopilotId
            if (id === null) {
              what = 'Mobile Copilot Id'
            }
          } else if (this.source.substring(0, 9) === 'TestDrive') {
            id = this.location.testdriveId
            if (id === null) {
              what = 'Test Drive Copilot Id'
            }
          }
          if (id !== null) {
            let data = {
              firmFirm: null,
              firm: this.location.firm,
              firm2: found.firm,
              firmName: found.firmName,
              relationship: 3,
              isAdd: true,
              isRemove: false,
              isOptIn: false,
              drpId: null,
              isDrpChanged: false,
              parent: null,
              parentName: null,
              id: id,
              source: this.source
            }
            console.log('Push Insurance', data)
            this.pushInsurance(data)
          } else {
            alert(`Please establish an Id for ${what} first.`)
          }
          this.$refs.searchLocation.clear()
          this.$refs.searchLocation.clearSearch()
        }
        this.$emit('changed')
      })
    },
    changedDrp(location, value) {
      this.isSave = true
      // Held per shop/insurer pair, not per source, so every row for this insurer
      // moves together and the grid cannot show two values for one pair.
      let matches = this.insurance.filter((x) => parseInt(x.firm2) === parseInt(location.firm2))
      for (let match of matches) {
        match.drpId = value
        match.isDrpChanged = true
      }
      this.$emit('changed')
    },
    checkedOptIn(location) {
      this.isSave = true
      let found = this.insurance.find((x) => x.firm2 === location.firm2 && x.source === location.source)
      if (found) {
        found.isOptIn = !found.isOptIn
      }
      console.log('Checked Insurance', this.insurance)
      this.$emit('changed')
    },
    removeLocation(firm) {
      this.isSave = true
      this.popInsurance(firm)
      console.log('Removed Insurance', {
        id: firm,
        network: this.insurance
      })
      this.$emit('changed')
    },
    async save() {
      if (this.isSave) {
        await this.saveMembership()
        // After the opt-in rows: a DRP for a pair that was just added needs the
        // FirmFirm row to exist before LaunchPad can work out where to mirror it.
        await this.saveDrps()
        return {
          valid: true,
          msg: null
        }
      } else {
        return null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-firm-list-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
  height: 400px;
}
.custom-source {
  margin-top: 8px;
}
.custom-header {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #ced4da;
}
.custom-list {
  list-style: none;
  li {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.custom-row {
  width: 100%;
  display: inline;
}
.custom-user-role {
  text-align: center;
  span {
    font-weight: 500;
  }
}
.custom-trash {
  color: rgb(173, 0, 0);
  :hover {
    cursor: pointer;
  }
}
</style>
